/**
 * Currency Utility
 * Centralized currency formatting for the application
 */

// Default currency configuration
const CURRENCY_CONFIG = {
    code: 'INR',
    symbol: '₹',
    locale: 'en-IN',
    decimals: 2
};

/**
 * Format amount with currency symbol
 * @param {number} amount - The amount to format
 * @param {object} options - Optional configuration
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, options = {}) => {
    const {
        code = CURRENCY_CONFIG.code,
        locale = CURRENCY_CONFIG.locale,
        decimals = CURRENCY_CONFIG.decimals,
        showSymbol = true
    } = options;

    const numAmount = Number(amount || 0);

    if (showSymbol) {
        // Format with locale-specific formatting
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: code,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }).format(numAmount);
    }

    // Format without currency symbol
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(numAmount);
};

/**
 * Get currency symbol
 * @returns {string} Currency symbol
 */
export const getCurrencySymbol = () => CURRENCY_CONFIG.symbol;

/**
 * Get currency code
 * @returns {string} Currency code
 */
export const getCurrencyCode = () => CURRENCY_CONFIG.code;

/**
 * Parse currency string to number
 * @param {string} currencyString - Currency string to parse
 * @returns {number} Parsed number
 */
export const parseCurrency = (currencyString) => {
    if (typeof currencyString === 'number') return currencyString;
    const cleaned = String(currencyString).replace(/[^\d.-]/g, '');
    return parseFloat(cleaned) || 0;
};

const currencyUtils = {
    formatCurrency,
    getCurrencySymbol,
    getCurrencyCode,
    parseCurrency,
    CURRENCY_CONFIG
};

export default currencyUtils;
